import { render } from "./LandingFooter.vue?vue&type=template&id=1c63a620&scoped=true&ts=true&lang=pug"
import script from "./LandingFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingFooter.vue?vue&type=script&lang=ts&setup=true"

import "./LandingFooter.vue?vue&type=style&index=0&id=1c63a620&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c63a620"]])

export default __exports__